var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 25 25"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22.5,
  height: 22.5,
  x: 1.74,
  y: 0.781,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  rx: 6
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.99,
  cy: 12.031,
  r: 5,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M20.34 5.18a.5.5 0 1 1-1 0M19.34 5.18a.5.5 0 0 1 1 0"
})));
export default SvgInstagram;